import { useParams } from 'react-router-dom';

export const HUB_BASE_URL = 'https://capitol-view-stay.com';

export const HUB_PROPERTIES = [
  { slug: 'capitol-hill-1', id: 'cv-001', name: 'Capitol Hill 1' },
  { slug: 'capitol-hill-2', id: '8457ce82-f8f8-4ee0-b6d1-36f47939979b', name: 'Capitol Hill 2' },
  { slug: 'capitol-hill-3', id: 'cv-002', name: 'Capitol Hill 3' },
  { slug: 'capitol-hill-4', id: 'cv-003', name: 'Capitol Hill 4' },
  { slug: 'capitol-view-1', id: 'cv-004', name: 'Capitol View 1' },
  { slug: 'capitol-view-2', id: 'cv-005', name: 'Capitol View 2' },
  { slug: 'capitol-view-3', id: 'cv-006', name: 'Capitol View 3' },
];

export const HUB_PAGES = [
  { key: 'wifi', label: 'Wi-Fi' },
  { key: 'guidebook', label: 'House Guidebook' },
  { key: 'local-guide', label: 'Local Guide' },
  { key: 'social', label: 'Social & Reviews' },
  { key: 'book', label: 'Book Direct' },
];

export const PETWORTH_IDS = ['cv-004', 'cv-005', 'cv-006'];

export const slugForId = (id) => HUB_PROPERTIES.find((p) => p.id === id)?.slug || id;

export const useHubProperty = () => {
  const { slug } = useParams();
  const match = HUB_PROPERTIES.find((p) => p.slug === slug || p.id === slug);
  return { slug: match?.slug || slug, propertyId: match?.id || slug, hubProperty: match };
};

export const hubPath = (slug, page) => (page ? `/${slug}/${page}` : `/hub/${slug}`);

export const hubUrl = (slug, page) => `${HUB_BASE_URL}/${slug}/${page}`;

export const HUB_SEO_PAGES = [
  { id: 'hub', name: 'Hub Home', path: '/hub/capitol-hill-1' },
  { id: 'hub-wifi', name: 'Hub · Wi-Fi', path: '/capitol-hill-1/wifi' },
  { id: 'hub-guidebook', name: 'Hub · Guidebook', path: '/capitol-hill-1/guidebook' },
  { id: 'hub-local-guide', name: 'Hub · Local Guide', path: '/capitol-hill-1/local-guide' },
  { id: 'hub-social', name: 'Hub · Social', path: '/capitol-hill-1/social' },
  { id: 'hub-book', name: 'Hub · Book Direct', path: '/capitol-hill-1/book' },
];

export const HUB_SEO_DEFAULTS = {
  hub: {
    meta_title: 'Guest Hub – {property} | Capitol View Stays',
    meta_description: 'Everything you need for your stay at {property}: Wi-Fi, house guidebook, local recommendations and direct booking discounts.',
    meta_keywords: 'guest hub, Capitol View Stays, Washington DC rental',
  },
  'hub-wifi': {
    meta_title: 'Wi-Fi – {property} | Capitol View Stays',
    meta_description: 'Get connected instantly at {property}. Tap to reveal your Wi-Fi network and password.',
    meta_keywords: 'wifi, guest wifi, Capitol View Stays',
    no_index: true,
  },
  'hub-guidebook': {
    meta_title: 'House Guidebook – {property} | Capitol View Stays',
    meta_description: 'Check-in details, house rules and how-tos for your stay at {property}.',
    meta_keywords: 'house guidebook, check-in, house rules, Capitol View Stays',
    no_index: true,
  },
  'hub-local-guide': {
    meta_title: 'Local Guide – {property} | Capitol View Stays',
    meta_description: 'Host-picked restaurants, coffee shops and attractions near {property} in Washington DC.',
    meta_keywords: 'Washington DC local guide, Capitol Hill restaurants, Petworth coffee',
  },
  'hub-social': {
    meta_title: 'Follow Capitol View Stays – {property}',
    meta_description: 'Follow @capitolviewstay on Instagram and Facebook. Tag us for a chance to be featured.',
    meta_keywords: 'Capitol View Stays Instagram, DC short term rental',
  },
  'hub-book': {
    meta_title: 'Book Direct & Save 35% – {property} | Capitol View Stays',
    meta_description: 'Book {property} directly with promo code CVS101 and save 35% on your next Washington DC stay.',
    meta_keywords: 'book direct DC, Capitol View Stays discount, CVS101',
  },
};
